/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services')
    .factory('GiftItem_Resource', 
    ["$resource", "$location", 
        function ($resource, $location) {
            var baseUrl = $location.protocol()  + "://" + $location.host() + 
                ($location.port() && ":" + $location.port())  + "/";
            var  resourceSaleS = $resource(baseUrl + 'rest/giftItems/:id',{}, {
                get:   { method: 'GET' },
                sendMail: {
                    method: 'POST',
                    url: baseUrl + 'rest/giftItems/:id/sendMail'
                }
            });
            return resourceSaleS;
        }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('GiftItem',["GiftItem_Resource","GiftItemData","HumanResourceData","CustomerData", "ServiceData","TaxMode","SaleItem","GiftItemRootCategory","GiftItemByHrRootCategory","TypeOfBooking",
        function (GiftItem_Resource,GiftItemData,HumanResourceData,CustomerData,ServiceData,TaxMode,SaleItem,GiftItemRootCategory,GiftItemByHrRootCategory,TypeOfBooking)
    {
        //GiftItem inherit from Activity
        var  GiftItem = function (giftItemRes,isPreviousVersion, isApplicationLoading)
        {
            SaleItem.call(this);

            this.id = null;
            this.code = null;
            this.service = null;
            this._serviceId=null;  //tmp for loading only
            this.price = 0;
            this.vat = null;
            this.vatCode = null;
            this.originalPrice = 0;
            this.discountPercent = 0;
            this.isUsed=false;
            this.isCanceled=false;
            this.closingDate = null;
            this.sale = null;
            this.humanResource = null;
            this.validityDate = null;
            this.editionType = "";
            this.customer = null;
            this._customerId=null;  //tmp for loading only
            this.barcodeData = "";//write only
            this.messageTitle ="";
            this.message ="";
            this.imageUrl ="";
            this.comment ="";
            this.version = null;
            this.loadObject(giftItemRes)
            if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA  and to customer
            {
                this.loadRef(null, isApplicationLoading);
                GiftItemData.add(this);
            }
        }

        GiftItem.prototype = Object.create(SaleItem.prototype);//inherit functions from SaleItem


        GiftItem.prototype.loadObject = function(object)
        {

            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id=object.id;
                this.code=object.code;
                this._serviceId=object.serviceId;
                this.price=object.price;
                this.vat=object.vat;
                this.vatCode=object.vatCode;
                this.isUsed=object.isUsed;
                this.isCanceled=object.isCanceled;
                if (object.closingDate) {
                    this.closingDate = new Date(object.closingDate);
                }
                if (object.originalPrice!==undefined && object.originalPrice)
                    this.originalPrice=object.originalPrice;
                else
                    this.originalPrice=object.price;
                this.discountPercent=object.discountPercent;
                if (object.humanResourceId)
                    this.humanResource = HumanResourceData.getById(object.humanResourceId);
                if (object.validityDate)
                    this.validityDate = new Date(object.validityDate);
                this.editionType = object.editionType;
                this._customerId=object.customerId;
                this.barcodeData=object.barcodeData;
                this.messageTitle=object.messageTitle;
                this.message=object.message;
                this.imageUrl=object.imageUrl;
                this.comment=object.comment;
                if (object.version)
                    this.version = object.version;
            }
        };
        GiftItem.prototype.loadRef = function(isPreviousVersion, isApplicationLoading)
        {
            if (this._customerId)
            {
                this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
                if (this.customer && (isPreviousVersion===undefined || !isPreviousVersion)) {
                    this.customer.addGiftItem(this);
                }
            }
            if (this._serviceId)
                this.service = ServiceData.getById(this._serviceId);
        };
        GiftItem.prototype.copyDataTo = function(object)
        {

            object.id=this.id;
            object.code=this.code;
            object.price=this.price;
            object.vat=this.vat;
            object.vatCode=this.vatCode;
            object.isUsed=this.isUsed;
            object.isCanceled=this.isCanceled;
            if (this.closingDate) {
                object.closingDate = this.closingDate;
            }
            object.originalPrice=this.originalPrice;
            object.discountPercent=this.discountPercent;
            if (this.humanResource)
                object.humanResourceId = this.humanResource.id;
            else
                this.humanResource = null;

            if (this.sale)
                object.saleId = this.sale.id;
            else
                object.saleId = null;
            if (this.service)
                object.serviceId = this.service.id;
            else
                object.serviceId = null;
            object.validityDate = this.validityDate;
            object.editionType = this.editionType;
            if (this.customer)//always save it
                object.customer = this.customer.getObjectResource();
            else
                object.customer = null;
            object.barcodeData=this.barcodeData;
            object.messageTitle=this.messageTitle;
            object.message=this.message;
            object.imageUrl=this.imageUrl;
            object.comment=this.comment;
        };
        GiftItem.prototype.getObjectResource = function()
        {
            var giftItemRes = new GiftItem_Resource();
            this.copyDataTo(giftItemRes);
            return giftItemRes;
        };
        GiftItem.prototype.setIdUsingObject = function(object)
        {
            this.id = object.id;
        };
        GiftItem.prototype.setId = function(id)
        {
            this.id = id;
        };
        GiftItem.prototype.getId = function()
        {
            return this.id;
        };
        GiftItem.prototype.getPrice = function()
        {
            return this.price;
        };
        GiftItem.prototype.getDiscountPrice = function(taxMode)
        {
            var price = 0;

            if (this.sale.isStatusSoldOrCreditOrCanceled()) {

                 price = this.price;

                //apply global discount on price
                if (this.sale .discountPercent != 0) {
                    price -= this.sale.discountPercent * price / 100;
                }
                if(taxMode === TaxMode.HT){
                    var vat = this.vat?this.vat:this.sale.vat;
                    price = price / (100 + vat) * 100;
                }
            }

            return price;
        };

        GiftItem.prototype.getSale = function()
        {
            return this.sale;
        };

        /**
         * @override SaleItem.prototype.matchSpecificMatchingOfItem
         */
        GiftItem.prototype.matchSpecificMatchingOfItem = function(saleObject){
            let matchSpecificMatchingOfItem = false;
            if( (saleObject === GiftItemRootCategory) ||
                (saleObject === GiftItemByHrRootCategory) ||
                (saleObject === GiftItemRootCategory.subCategories.SERVICE && this.service !== null ) ||
                (saleObject === GiftItemRootCategory.subCategories.PRICE && this.service === null) ||
                (saleObject === TypeOfBooking.CREATE_BY_CUSTORMER  && this.getSale().isCreatedByCustomer) ||
                (saleObject === TypeOfBooking.NOT_CREATE_BY_CUSTOMER  && !this.getSale().isCreatedByCustomer)) {
                matchSpecificMatchingOfItem = true;
            }
            return matchSpecificMatchingOfItem;
        };

        /**
         * @override SaleItem.prototype.isSaleWithTree
         */
        GiftItem.prototype.isSaleWithTree = function(){
            return false;
        };

        /**
         * @override SaleItem.prototype.incrementSalesDatas
         */
        GiftItem.prototype.incrementSalesDatas = function(salesData, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, currentDay){
            if(this.matchAllSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, currentDay)) {
                salesData.price += this.getDiscountPrice(taxMode);
                if (salesData.sales.indexOf(this.getSale()) === -1 && !this.getSale().isCancelledOrCredit()) {
                    if (!this.getSale().booking && salesData.salesWithoutBooking.indexOf(this.getSale()) === -1) {
                        salesData.salesWithoutBooking.push(this.getSale());
                    }
                    if (this.getSale().booking && this.getSale().booking.day && firstDayOfPeriod && lastDayOfPeriod && (this.getSale().booking.day.id < firstDayOfPeriod.id || this.getSale().booking.day.id > lastDayOfPeriod.id) && salesData.salesWithBookingOutOfPeriod.indexOf(this.getSale()) === -1) {
                        salesData.salesWithBookingOutOfPeriod.push(this.getSale());
                    }
                    if (salesData.customersSales.indexOf(this.getSale().customer) === -1) {
                        salesData.customersSales.push(this.getSale().customer);
                        if (salesData.customersFirstSales.indexOf(this.getSale().customer) === -1 && this.getSale().customer && !this.getSale().customer.hasSaleBetween(firstDayOfPeriod, currentDay) && !this.getSale().customer.hasBookingBetween(firstDayOfPeriod, currentDay, this.getSale())) {
                            salesData.customersFirstSales.push(this.getSale().customer);
                        }
                    }
                }
                salesData.subSales.push(this);
                salesData.subSalesStep.push(this);
                salesData.qteSubSales += this.getStatQuantity();

                if (salesData.sales.indexOf(this.getSale()) === -1) {
                    salesData.sales.push(this.getSale());
                    salesData.qteSales += this.getStatQuantity();
                }
            }
        };

        return GiftItem;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('GiftItemSrv', ["$log", "ServerSrv", "GiftItem_Resource", "GiftItemData", "GiftItem", "SaleData",
        function($log, ServerSrv, GiftItem_Resource, GiftItemData, GiftItem, SaleData) {
            var  bpSrv = {};

            bpSrv.save =  function(giftItem,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(bpSrv.saveSync, giftItem, successFunction, errorFunction);
            };
            
            bpSrv.saveSync =  function(giftItem,successFunction,errorFunction)
            {
                //$timeout (function () {

                var bsRes = giftItem.getObjectResource();
                bsRes.$save({}, //no params
                    function (data) {

                        try {
                            // now we can set the id
                            giftItem.setId(data.id);
                            giftItem.code = data.code;
                            if (!giftItem.version || (data.version && data.version > giftItem.version))
                                giftItem.version = data.version;
                            if (data.customerId && giftItem.customer)
                                giftItem.customer.setId(data.customerId);
                            //Add user action
                            //UserActionSrv.add(data.userAction);
                            //CallBack on success
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction !=undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            bpSrv.updateLocally =  function(id,resource)
            {
                var giftItem =  GiftItemData.getById(id);

                if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version)
                    return null;

                if (giftItem!=null)
                {
                    giftItem.loadObject(resource);
                    giftItem.id = id;
                    //remove from sale
                    if(giftItem.sale)
                        giftItem.sale.removeGiftItem(giftItem);
                    if(resource.saleId)//add to sale
                    {
                        var sale = SaleData.getById(resource.saleId);
                        if (sale)
                            sale.addGiftItem(giftItem);
                    }
                }
                else
                    bpSrv.addLocally(id,resource);

                return giftItem;

            };
            bpSrv.removeLocally =  function(id,resource)
            {
                var giftItem =  GiftItemData.getById(id)    ;
                if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version)
                    return null;
                if (giftItem!=null)
                {
                    //remove from sale
                    if(giftItem.sale)
                        giftItem.sale.removeGiftItem(giftItem);
                }
                return giftItem;
            };
            bpSrv.addLocally =  function(id,resource)
            {
                var giftItem =  GiftItemData.getById(id);
                if (giftItem && giftItem.version && resource.version && resource.version < giftItem.version)
                    return null;
                if (giftItem!=null) //check if resource already exist inside index (current action could be a 'cancel')
                    giftItem.loadObject(resource);
                else
                    giftItem = new GiftItem(resource);
                giftItem.id = id;
                //add to sale
                if(resource.saleId)
                {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale)
                        sale.addGiftItem(giftItem);
                }

                return giftItem;
            };

            bpSrv.getPreviousVersionInstance =  function(resource)
            {
                var giftItem =  new GiftItem(resource,true);
                if(resource.saleId)
                    giftItem.sale = SaleData.getById(resource.saleId);
                return giftItem;

            };

            bpSrv.sendMail = function(giftItem) {
                GiftItem_Resource.sendMail({ id: giftItem.id }, {})
                    .$promise.then( (result) => {
                        // console.log(JSON.stringify(result));
                    }).catch( (error) => {
                        console.log(JSON.stringify(error));
                    });
            }

            return bpSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('GiftItemData',["$log", function ($log)
    {
        var  giftItemData =
        {
            indexGiftItems : []
        };
        giftItemData.getById =  function(giftItemId)
        {
            for (var i=0;i<this.indexGiftItems.length;i++)
                if (this.indexGiftItems[i].id==giftItemId)
                    return this.indexGiftItems[i];
            return null;
        };
        giftItemData.getIndexOf =  function(giftItem)
        {
            if (giftItem)
                return this.indexGiftItems.indexOf(giftItem);
            return -1;
        };
        giftItemData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexGiftItems.length)
                return this.indexGiftItems[index];
            else
                return null;
        };
        giftItemData.getByCode =  function(code)
        {
            var codeToFind ="";
            if (code)
                codeToFind = code.replace(/-/g,"");
            for (var i=0;i<this.indexGiftItems.length;i++)
                if (this.indexGiftItems[i].code==codeToFind)
                    return this.indexGiftItems[i];
            return null;
        };
        giftItemData.getByValidityDate =  function(validityDate,isCanceled)
        {
            var giftItems = [];
            for (var i=0;i<this.indexGiftItems.length;i++)
                if (this.indexGiftItems[i].validityDate &&
                    this.indexGiftItems[i].validityDate.getFullYear()==validityDate.getFullYear() &&
                    this.indexGiftItems[i].validityDate.getMonth()==validityDate.getMonth() &&
                    this.indexGiftItems[i].validityDate.getDate()==validityDate.getDate() &&
                    this.indexGiftItems[i].isCanceled == isCanceled)
                    giftItems.push(this.indexGiftItems[i]);
            return giftItems;
        };

        giftItemData.getByClosingDate = function(date) {
            let giftItems = [];
            for (let i=0;i<this.indexGiftItems.length;i++) {
                let giftItem = this.indexGiftItems[i];
                if (giftItem.isCanceled) {
                    let closingDate = giftItem.closingDate;

                    if (!closingDate && giftItem.validityDate) {
                        closingDate = giftItem.validityDate;
                    }

                    if (closingDate && closingDate.getFullYear() === date.getFullYear() &&
                        closingDate.getMonth() === date.getMonth() && closingDate.getDate() === date.getDate()) {
                        giftItems.push(giftItem);
                    }
                }
            }
            return giftItems;
        };

        giftItemData.add =  function(giftItem)
        {
            this.indexGiftItems.push(giftItem);
            return this.indexGiftItems.length-1;
        };
        giftItemData.clear =  function()
        {
            giftItemData.indexGiftItems = [];
        };
        giftItemData.getActiveList =  function()
        {
            return this.indexGiftItems;
        }

        return giftItemData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/GiftItem.js